import AxiosWrapper from '../repositories/AxiosWrapper'
import { AxiosResponse } from 'axios/index'
import APIHeaders from '@/entities/APIHeaders'
import DailyForAWeek from '@/entities/DailyForAWeek'
import WeeklyForAMonth from '@/entities/WeeklyForAMonth'
import * as JsonUtils from '@/utils/JsonUtils'


export const dailyForAWeek = (headers: APIHeaders, childId:number, toDate?: string) : Promise<DailyForAWeek[]> => {
  return new Promise<DailyForAWeek[]>(async (resolve, reject) => {

    const axios = AxiosWrapper(headers)
    if (axios instanceof Error) {
      return reject(axios)
    }

    let parameters = {}
    if (toDate !== undefined) {
      parameters = {
        to_date: toDate,
      };
    }

    let response: AxiosResponse
    try {
      response = await axios.get(`/v1/charts/children/${childId}/daily_for_a_week.json`, {
        params: parameters,
      })
    }catch (e) {
      return reject(e)
    }

    const apiResult = response.data

    try {
      const output = await JsonUtils.deserializeArray<DailyForAWeek>(apiResult, DailyForAWeek)
      return resolve(output)
    } catch (e) {
      return reject(e)
    }
  })
}


//
export const weeklyForAMonth = (headers: APIHeaders, childId:number, toDate?: string) : Promise<WeeklyForAMonth[]> => {
  return new Promise<WeeklyForAMonth[]>(async (resolve, reject) => {

    const axios = AxiosWrapper(headers)
    if (axios instanceof Error) {
      return reject(axios)
    }

    let parameters = {}
    if (toDate !== undefined) {
      parameters = {
        to_date: toDate,
      };
    }

    let response: AxiosResponse
    try {
      response = await axios.get(`/v1/charts/children/${childId}/weekly_for_a_month.json`, {
        params: parameters,
      })
    }catch (e) {
      return reject(e)
    }

    const apiResult = response.data

    try {
      const output = await JsonUtils.deserializeArray<WeeklyForAMonth>(apiResult, WeeklyForAMonth)
      return resolve(output)
    } catch (e) {
      return reject(e)
    }
  })
}
